import Glide from '@glidejs/glide';

export default function (dom, opts) {
    let options = {
        bigSliderSel: '.brand-slider--big',
        smallSliderSel: '.brand-slider--small',
        ...opts
    };

    let optionsBig = {
        type: 'carousel',
        perView: 1,
        gap: 0,
        keyboard: false,
        autoplay: false,
        swipeThreshold: 80,
        dragThreshold: 120,
        perTouch: 1,
        touchRatio: 0.5,
        touchAngle: 45,
        rewind: true,
    };

    let optionsSmall = {
        type: 'carousel',
        perView: 7,
        gap: 0,
        keyboard: false,
        autoplay: false,
        breakpoints: {
            1279: {
                perView: 5
            },
            900: {
                perView: 4
            },
            600: {
                perView: 3
            }
        },
        swipeThreshold: 80,
        dragThreshold: 120,
        perTouch: 1,
        touchRatio: 0.5,
        touchAngle: 45,
        rewind: true,
    };

    const sliderBig = dom.querySelector(options.bigSliderSel);
    const sliderSmall = dom.querySelector(options.smallSliderSel);
    const slideCountBig = [].slice.call(sliderBig.querySelectorAll('.glide__slide'), 0).length;
    const slideCountSmall = [].slice.call(sliderSmall.querySelectorAll('.glide__slide'), 0).length;

    if (slideCountBig == slideCountSmall) {
        const glideBig = new Glide(sliderBig.querySelector('.glide'), optionsBig).mount();
        const glideSmall = new Glide(sliderSmall.querySelector('.glide'), optionsSmall).mount();

        glideSmall.on('run', (move) => {
            // console.log(move, glideSmall.index);
            if( glideBig.index !== glideSmall.index) {
                glideBig.go(`=${glideSmall.index}`)
            }
        })

        glideBig.on('run', (move) => {
            // console.log(move, glideSmall.index);
            if( glideBig.index !== glideSmall.index) {
                glideSmall.go(`=${glideBig.index}`)
            }
        })
    }
}
